import React, {useCallback, useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {fetchData, postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {Guard} from "../Common/Guard";
import {PERMS} from "../../Utils/Permissions";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import Map from "../Map/Map";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import PageLayout from "../Layout/PageLayout";
import {Card, CardTitleBar, CardBody, FormField, TextInput, Select, Button, Tabs, Spinner, StatusBadge} from "../UI";
import {tokens, mq} from "../../theme/tokens";

const TwoCol = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${tokens.spacing[5]};
    ${mq.lg} { grid-template-columns: 1.4fr 1fr; }
`;

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: ${tokens.typography.size.base};
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: top;
    }
    td:first-child { color: ${tokens.colors.muted}; width: 40%; }
    td:last-child { color: ${tokens.colors.heading}; font-weight: ${tokens.typography.weight.bold}; }
    tr:last-child td { border-bottom: 0; }
`;

const GridTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: ${tokens.typography.size.base};
    th {
        text-align: left;
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        background: ${tokens.colors.cream};
        color: ${tokens.colors.muted};
        font-size: ${tokens.typography.size.xs};
        text-transform: uppercase;
        letter-spacing: 0.06em;
        font-weight: ${tokens.typography.weight.bold};
        border-bottom: 1px solid ${tokens.colors.border};
        white-space: nowrap;
    }
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: top;
        color: ${tokens.colors.body};
    }
`;

const TableScroll = styled.div`
    overflow-x: auto;
`;

const Row = ({label, children}) => (
    <tr>
        <td>{label}</td>
        <td>{children}</td>
    </tr>
);

const RiderDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({name: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [idNumber, setIDNumber] = useState('');
    const [vehicleRegNo, setVehicleRegNo] = useState('');
    const [areaID, setAreaID] = useState('');
    const [regionID, setRegionID] = useState('');
    const [regionList, setRegionList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [mapCentre, setMapCentre] = useState({});
    const [requestsList, setRequestList] = useState([]);
    const [tab, setTab] = useState("details");


    const [ledger, setLedger] = useState([]);
    const [financialAction, setFinancialAction] = useState(null); // 'penalty' | 'reward' | null
    const [amountKES, setAmountKES] = useState('');

    const {id} = props.match.params;

    const loadLedger = useCallback(() => {
        fetchData(Endpoints.RIDER_LEDGER(id))
            .then((r) => r.json())
            .then((res) => setLedger((res && res.data) || []))
            .catch((err) => console.log(err));
    }, [id]);

    useEffect(() => { loadLedger(); }, [loadLedger]);

    const submitAdjust = (reason) => {
        const cents = Math.round(parseFloat(amountKES) * 100);
        if (!Number.isFinite(cents) || cents <= 0) return;
        const fd = new FormData();
        fd.append('amount_cents', String(cents));
        fd.append('reason', reason);
        const endpoint = financialAction === 'penalty'
            ? Endpoints.POST_RIDER_PENALTY(id)
            : Endpoints.POST_RIDER_REWARD(id);
        postData(endpoint, fd)
            .then(() => {
                setFinancialAction(null);
                setAmountKES('');
                loadLedger();
            })
            .catch((err) => console.log(err));
    };

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.RIDER_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.name);
                    setPhone(res.data.phone);
                    setEmail(res.data.email);
                    setIDNumber(res.data.id_number);
                    setRegionID(res.data.region_id);
                    setAreaID(res.data.area_id);
                    setVehicleRegNo(res.data.reg_no)
                    setMapCentre({
                        lat: res.data.current_lat,
                        lng: res.data.current_lng
                    })
                    loadRegions(res.data.area_id)
                    updateDocumentTitle(res.data.name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
        loadAreas()
        loadRequests(false)
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.RIDER_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(SUCCESS ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);

                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateDetails(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("id", id);
        data.append("name", name)
        data.append("email", email)
        data.append("phone", phone)
        data.append("id_number", idNumber)
        data.append("reg_no", vehicleRegNo)
        data.append("area_id", areaID)
        data.append("region_id", regionID)

        setIsLoading(true)
        postData(Endpoints.RIDER_UPDATE_DETAILS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(SUCCESS ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadAreas() {
        let data = new FormData();
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.AREA_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setAreaList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRegions(id) {
        let data = new FormData();
        data.append("area_id", id);
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.REGION_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRegionList(res.data || []);
                    if (res.data.length > 0) setRegionID(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const loadRequests = (loadMore) => {
        let data = new FormData();
        data.append("id", id);
        data.append("offset", requestsList.length);

        setIsLoading(true);

        postData(Endpoints.REQUEST_LIST_RIDER, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                let currentPosts = loadMore ? requestsList : [];
                currentPosts = currentPosts.concat(...res.data);
                setRequestList(currentPosts);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };


    return (
        <PageLayout
            title={item.name}
            actions={
                <div style={{display: 'inline-flex', alignItems: 'center', gap: tokens.spacing[3]}}>
                    {isLoading && <Spinner size={20}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.status === 1 ? 0 : 1)}
                    >{item.status === 1 ? "Deactivate" : "Activate"}</Button>
                    }
                    <Link to="/riders">
                        <Button variant="outline">Back to riders</Button>
                    </Link>
                </div>
            }
        >
            {item.name !== '' &&
            <>
                <Tabs
                    tabs={[
                        {key: "details", label: "Details"},
                        {key: "requests", label: "Requests handled"},
                        {key: "reviews", label: "Reviews"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <TwoCol>
                    <Card padded={false}>
                        <CardTitleBar title="Rider details"/>
                        <InfoTable>
                            <tbody>
                            <Row label="Name">{item.name}</Row>
                            <Row label="Rider code">{item.rider_code}</Row>
                            <Row label="Email">{item.email}</Row>
                            <Row label="Phone">{item.phone}</Row>
                            <Row label="ID Number">{item.id_number}</Row>
                            <Row label="Reg No">{item.reg_no}</Row>
                            <Row label="Completed tasks">{item.completed_jobs}</Row>
                            <Row label="Ongoing tasks">{item.ongoing_jobs}</Row>
                            <Row label="Cancelled tasks">{item.cancelled_jobs}</Row>
                            <Row label="Received jobs">{item.received_jobs}</Row>
                            <Row label="Rejected jobs">{item.rejected_jobs}</Row>
                            <tr>
                                <td>Status</td>
                                <td>
                                    <StatusBadge status={item.status === 1 ? "active" : "inactive"}>
                                        {item.status === 0 ? "INACTIVE" : "ACTIVE"}
                                    </StatusBadge>
                                </td>
                            </tr>
                            <Row label="Registered on">{item.date_added}</Row>
                            <tr>
                                <td>Current location</td>
                                <td style={{minWidth: 400}}>
                                    <Map showCircle={true} mapCentre={mapCentre} radius={item.radius}/>
                                </td>
                            </tr>
                            </tbody>
                        </InfoTable>
                    </Card>

                    <Card padded={false}>
                        <CardTitleBar title="Update rider"/>
                        <CardBody>
                            <form onSubmit={updateDetails}>

                                <FormField label="Full name">
                                    <TextInput type="text"
                                               required
                                               value={name}
                                               onChange={e => setName(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Email">
                                    <TextInput type="text"
                                               required
                                               value={email}
                                               onChange={e => setEmail(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Phone number">
                                    <TextInput type="text"
                                               required
                                               value={phone}
                                               onChange={e => setPhone(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Vehicle registration number">
                                    <TextInput type="text"
                                               required
                                               value={vehicleRegNo}
                                               onChange={e => setVehicleRegNo(e.target.value)}
                                    />
                                </FormField>

                                <FormField label="Select area">
                                    <Select value={areaID}
                                            onChange={({target}) => setAreaID(target.value)}>
                                        {areaList.map((i, k) => <option
                                            value={i.id}>{i.title}</option>
                                        )}
                                    </Select>
                                </FormField>

                                <FormField label="Select region">
                                    <Select value={regionID}
                                            onChange={({target}) => setRegionID(target.value)}>
                                        {regionList.map((i, k) => <option
                                            value={i.id}>{i.title}</option>
                                        )}
                                    </Select>
                                </FormField>

                                <p style={{margin: `0 0 ${tokens.spacing[4]}`, color: tokens.colors.muted, fontSize: tokens.typography.size.sm}}>
                                    *Rider will be required to re-login on their app
                                </p>

                                <Button type="submit" loading={isLoading}>Update</Button>

                            </form>
                        </CardBody>
                    </Card>
                </TwoCol>
                }

                {tab === "requests" &&
                <Card padded={false}>
                    <TableScroll>
                        <GridTable>
                            <thead>
                            <tr>
                                <th>Request</th>
                                <th>Role</th>
                                <th>Code</th>
                                <th>Status</th>
                                <th>Receiving Details</th>
                                <th>Handing Over Details</th>
                            </tr>
                            </thead>
                            <tbody>
                            {requestsList.map((i, k) => <tr>
                                    <td><Link to={"/request/" + i.id}>#{i.request_code}</Link></td>
                                    <td>{i.role}</td>
                                    <td>{i.code}</td>
                                    <td>{i.status}</td>
                                    <td>
                                        <b>Time</b> : {i.accepting_time_string}<br/>
                                        <b>Location</b> : {i.accepting_location}<br/>
                                        <b>LatLng</b> : {i.accepting_lat}, {i.accepting_lng}<br/><br/>
                                        {i.accepting_signature === "" ? "-" : <img
                                            src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.accepting_signature}
                                            style={{height: 90}}/>}
                                    </td>
                                    <td>
                                        {i.status !== "PENDING" &&
                                        <div>
                                            <b>Time</b> : {i.handing_time_string}<br/>
                                            <b>Location</b> : {i.handing_location}<br/>
                                            <b>LatLng</b> : {i.handing_lat}, {i.handing_lng}<br/><br/>
                                            {i.handing_signature === "" ? "-" : <img
                                                src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.handing_signature}
                                                style={{height: 90}}/>}
                                        </div>
                                        }
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </GridTable>
                    </TableScroll>
                </Card>
                }

                {tab === "reviews" &&
                <Card padded={false}>
                    <TableScroll>
                        <GridTable>
                            <thead>
                            <tr>
                                <th>Request</th>
                                <th>Role</th>
                                <th>Code</th>
                                <th>Rider review</th>
                            </tr>
                            </thead>
                            <tbody>
                            {requestsList.map((i, k) => <tr>
                                    <td><Link to={"/request/" + i.id}>#{i.request_code}</Link></td>
                                    <td>{i.role}</td>
                                    <td>{i.code}</td>
                                    <td>
                                        <div>
                                            <b>Ratings</b> : {i.rider_rating} / 5<br/>
                                            <b>Review</b> : {i.rider_review}<br/>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </GridTable>
                    </TableScroll>
                </Card>
                }

                <Guard permission={PERMS.FINANCIAL_READ}>
                    <Card style={{marginTop: tokens.spacing[4]}}>
                        <CardTitleBar title="Ledger"/>
                        <div style={{display: 'flex', gap: tokens.spacing[5], margin: `${tokens.spacing[3]} 0`}}>
                            <div><strong>Main:</strong> KES {((item.main_balance_cents || 0) / 100).toFixed(2)}</div>
                            <div><strong>Reward:</strong> KES {((item.reward_pool_cents || 0) / 100).toFixed(2)}</div>
                            <div><strong>Penalty debt:</strong> KES {((item.penalty_debt_cents || 0) / 100).toFixed(2)}</div>
                        </div>

                        <Guard permission={PERMS.FINANCIAL_WRITE}>
                            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: tokens.spacing[2], marginBottom: tokens.spacing[3]}}>
                                <TextInput
                                    type="number" min="0" step="0.01"
                                    value={amountKES}
                                    onChange={(e) => setAmountKES(e.target.value)}
                                    placeholder="Amount (KES)"
                                    style={{width: 180}}
                                />
                                <Button variant="danger" disabled={!amountKES} onClick={() => setFinancialAction('penalty')}>Apply penalty</Button>
                                <Button variant="primary" disabled={!amountKES} onClick={() => setFinancialAction('reward')}>Issue reward</Button>
                                <a
                                    href={`${Endpoints.SERVER_HOST}/api/v1/statement?entity_type=rider&entity_id=${id}`}
                                    target="_blank" rel="noreferrer"
                                    style={{marginLeft: tokens.spacing[3]}}
                                >
                                    Download CSV statement
                                </a>
                            </div>
                        </Guard>

                        <h4 style={{fontSize: tokens.typography.size.base, fontWeight: tokens.typography.weight.bold, color: tokens.colors.heading, margin: `${tokens.spacing[3]} 0 ${tokens.spacing[2]}`}}>Recent entries</h4>
                        <ul style={{maxHeight: 300, overflow: 'auto', listStyle: 'none', padding: 0, margin: 0}}>
                            {ledger.length === 0 && <li style={{color: tokens.colors.muted}}>No entries yet.</li>}
                            {ledger.map((e) => (
                                <li key={e.id} style={{padding: tokens.spacing[2], borderBottom: `1px solid ${tokens.colors.divider}`}}>
                                    <strong>{e.bucket}</strong> · {e.direction} KES {(e.amount_cents / 100).toFixed(2)} — {e.reason || '—'}
                                    <span style={{color: tokens.colors.faint, marginLeft: tokens.spacing[2]}}>{new Date(e.created_at).toLocaleString()}</span>
                                </li>
                            ))}
                        </ul>
                    </Card>

                    {financialAction && (
                        <ReasonCaptureModal
                            title={financialAction === 'penalty' ? 'Apply penalty' : 'Issue reward'}
                            onCancel={() => setFinancialAction(null)}
                            onConfirm={submitAdjust}
                        />
                    )}
                </Guard>
            </>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate rider" : "Activate rider"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }
        </PageLayout>
    )
};


export default RiderDetails
